<template>
  <div class="main-bg">
    <div class="frame">
      <div id="main" class="clearfix">
        <h2>畅游通行证注册</h2>
        <div id="sidebar" class="sidebar">
          <ul class="clearfix">
            <li class="mobile"><a href="javascript:void(0)" id="regPhone"
                :class="{ 'current': ruleForm.type == '1' }"><strong>手机注册</strong></a></li>
            <li class="person"><a href="javascript:void(0)" id="regPersonal"
                :class="{ 'current': ruleForm.type == '2' }"><strong>其他注册</strong></a>
            </li>
          </ul>
        </div>
        <div id="content" class="tab-content">
          <!-- ============================手机注册======================================== -->
          <div class="tab-pane" id="mobile" style="display: block;">
            <el-form class="form-wrapper" ref="ruleForm" :model="ruleForm" :rules="rules" :show-message="false"
              label-position="left" label-width="0">
              <div class="list clearfix">
                <el-form-item class="li" prop="phone" v-if="ruleForm.type == '1'">
                  <label>手机号码：</label>
                  <el-input class="wrap" type="text" v-model="ruleForm.phone" onpaste="return false" maxlength="11"
                    @input="ruleForm.phone = $event.replace(/\D/g, '')"></el-input>
                  <form-message prop="phone"></form-message>
                </el-form-item>
                <el-form-item class="li" prop="account" v-if="ruleForm.type == '2'">
                  <label>畅游通行证：</label>
                  <el-input class="wrap" type="text" v-model="ruleForm.account" maxlength="16"></el-input>
                  <span class="domain">@changyou.com</span>
                  <form-message prop="account"></form-message>
                </el-form-item>
                <el-form-item class="li" prop="password">
                  <label>设置密码：</label>
                  <el-input class="wrap" type="password" v-model="ruleForm.password" maxlength="16"
                    autocomplete="password" show-password
                    @focus="focusInput($event, '密码（5-16位小写字母及数字组成）', 'password')" />
                  <form-message prop="password"></form-message>
                </el-form-item>
                <el-form-item class="li" prop="password2">
                  <label>重复密码：</label>
                  <el-input class="wrap" type="password" v-model="ruleForm.password2" maxlength="16"
                    autocomplete="new-password" show-password />
                  <form-message prop="password2"></form-message>
                </el-form-item>
                <el-form-item class="li" prop="superPassword">
                  <label>超级密码：</label>
                  <el-input class="wrap" type="password" v-model="ruleForm.superPassword" maxlength="20"
                    autocomplete="new-password" show-password />
                  <form-message prop="superPassword"></form-message>
                </el-form-item>
                <el-form-item class="li" prop="smsCode" v-if="ruleForm.type == '1'">
                  <label>验证码：</label>
                  <el-input class="wrap input-code-wrapper" v-model="ruleForm.smsCode" />
                  <el-button class="other" type="text" :disabled="showVerifyCode" @click="showCapctchaCheckCode">{{
                    verifyCodeBtnText }}</el-button>
                  <form-message prop="smsCode"></form-message>
                </el-form-item>
                <el-form-item class="li">
                  <label for=""></label>
                  <div class="wrap"><a class="btn submit_btn"> <input type="button" tabindex="6" value="提交注册"
                        @click="handleReg"> </a>
                    <p class="user_agreement"><input type="checkbox" class="checkbox" v-model="checked" name="read"
                        id="read_phone">
                      <span style="font-size: 12px;">
                        同意并阅读畅游
                        <a target="_blank" href="/static/userAgreement.html">《用户协议》</a>
                        和
                        <a target="_blank" href="/static/privacyPolicy.html">《隐私政策》</a>
                      </span>
                    </p>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <!-- main end -->
      </div>
    </div>
    <Verify @success="capctchaCheckCodeSuccess" :mode="'pop'" :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }" ref="verifyCodeRef"></Verify>
  </div>
</template>

<script>
import { ajax_method, getLocParam } from '@/utils/utils.js';
import Verify from "@/components/Verifition/Verify";
import FormMessage from './formMessage.vue';
export default {
  components: {
    Verify,
    FormMessage
  },
  provide() {
    return {
      root: this
    }
  },
  data() {
    const searchStr = decodeURIComponent(location.href.split('?')[1]).replace(/\+/g, ' ')
    const [proxyId, gameId, partId] = searchStr.split('/')
    return {
      checked: false,
      ruleForm: {
        account: null,
        password: null,
        password2: null,
        superPassword: null,
        type: '2', // 1:手机，2：邮箱
        phone: null,
        smsCode: null,
        code: null
      },
      rules: {
        phone: [{
          required: true, trigger: 'blur', validator: (rule, value, callback) => {
            if (!value) {
              const message = '手机号码不能为空！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            var reg0 = /^1\d{10}$/;
            if (!reg0.test(value)) {
              const message = '请输入正确的手机号码！';
              this.showMessage({ type: 'warn', message }, { rule })
              callback(new Error(message))
            } else {
              this.showMessage({ type: 'success' }, { rule })
              callback()
            }
          }
        }],
        account: [{
          required: true, trigger: 'blur', validator: (rule, value, callback) => {
            if (!value) {
              const message = '账号不能为空！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (value.length < 5 || value.length > 16) {
              const message = '账号长度为5-16位！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (/[A-Z]/.test(value)) {
              const message = '不能输入大写字符！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (/[\W]/g.test(value)) {
              const message = '账号只能由小写字母与数字组成！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            this.showMessage({ type: 'success' }, { rule })
            return callback()
          }
        }],
        password: [{
          required: true, trigger: 'blur', validator: (rule, value, callback) => {
            if (!value) {
              const message = '密码不能为空！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (value.length < 5 || value.length > 16) {
              const message = '密码长度为5-16位！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (/[A-Z]/.test(value)) {
              const message = '不能输入大写字符！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (/[\W]/g.test(value)) {
              const message = '密码只能由字母与数字组成！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            this.showMessage({ type: 'success' }, { rule })
            return callback()
          }
        }],
        password2: [{
          required: true, trigger: 'blur', validator: (rule, value, callback) => {
            if (!value) {
              const message = '密码不能为空！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (this.ruleForm.password !== value) {
              const message = '2次输入密码不一致';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            this.showMessage({ type: 'success' }, { rule })
            return callback()
          }
        }],
        superPassword: [{
          required: true, trigger: 'blur', validator: (rule, value, callback) => {
            if (!value) {
              const message = '超级密码不能为空！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (value.length < 5 || value.length > 20) {
              const message = '超级密码长度为5-20位！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (/[A-Z]/.test(value)) {
              const message = '不能输入大写字符！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (/[\W]/g.test(value)) {
              const message = '密码只能由字母与数字组成！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            this.showMessage({ type: 'success' }, { rule })
            return callback()
          }
        }],
        smsCode: [{
          required: true, trigger: 'blur', validator: (rule, value, callback) => {
            if (!value) {
              const message = '验证码不能为空！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            this.showMessage({ type: 'success' }, { rule })
            return callback()
          }
        }],
      },
      formMessageRefs: [],
      proxyData: {
        weChat: null,
        qq: null
      },
      showVerifyCode: false,
      verifyNum: 60,
      verifyCodeBtnText: '获取验证码',
      searchData: {
        proxyId,
        gameId,
        partId
      }
    }
  },
  created() {
    this.getProxyData()
    this.getLoginMethod()
  },
  methods: {
    getLoginMethod() {
      ajax_method({
        data: { gameId: this.searchData.gameId },
        url: '/loginUser/setting',
        type: 'GET',
        dataType: 'json',
        timeout: 60000,
        contentType: "application/json",
        success: (res) => {
          const resjson = JSON.parse(res)
          if (resjson.code === 1) {
            this.ruleForm.type = resjson.data.regType
          }
        },
        error: function (error) { }
      })
    },
    getProxyData() {
      let url = `/proxy/get`;
      ajax_method({
        data: { proxyId: this.searchData.proxyId },
        url,
        type: 'POST',
        dataType: 'json',
        timeout: 60000,
        contentType: "application/json",
        success: (res) => {
          const resjson = JSON.parse(res)
          if (resjson.code === 1) {
            this.proxyData = resjson.data
            localStorage.setItem('proxyData', JSON.stringify(this.proxyData))
            return
          }
        },
        error: function (error) {
        }
      })
    },
    showCapctchaCheckCode() {
      if (!this.ruleForm.phone) {
        this.$message({ type: 'warn', message: '请输入手机号' });
        return;
      }
      this.$refs.verifyCodeRef.show();
    },
    capctchaCheckCodeSuccess(params) {
      this.ruleForm.code = params.captchaVerification;
      if (this.ruleForm.type == '2') {
        this.ajaxAdd();
        return;
      }
      let timer = setInterval(() => {
        this.showVerifyCode = true
        this.verifyNum--;
        this.verifyCodeBtnText = `${this.verifyNum}秒后重发`
        if (this.verifyNum === 0) {
          this.showVerifyCode = false;
          this.verifyCodeBtnText = '重新发送';
          this.verifyNum = 60
          clearInterval(timer)
        }
      }, 1000)
      ajax_method({
        data: {
          phone: this.ruleForm.phone,
          code: this.ruleForm.code,
          gameId: this.searchData.gameId
        },
        url: '/player/sms',
        type: 'POST',
        dataType: 'json',
        timeout: 60000,
        contentType: "application/json",
        success: (res) => {
          const resjson = JSON.parse(res)
          if (resjson.code === 1) {
            this.$message({
              type: 'success',
              message: '发送成功',
              duration: '2000',
            })
            return
          }
          this.$message({
            type: 'error',
            message: resjson.message || '发送失败',
            duration: '2000',
          })
        },
        error: function (error) {
          this.$message({
            type: 'error',
            message: error.message,
            duration: '2000',
          })
        }
      })
    },
    ajaxAdd() {
      let sendData = {
        proxyId: this.searchData.proxyId,
        gameId: this.searchData.gameId,
        partId: this.searchData.partId,
        account: this.ruleForm.account,
        password: this.ruleForm.password,
        superPassword: this.ruleForm.superPassword,
        code: this.ruleForm.code
      }
      if (this.ruleForm.type == '1') {
        sendData.account = this.ruleForm.phone;
        sendData.phone = this.ruleForm.phone;
        sendData.smsCode = this.ruleForm.smsCode;
      }
      let url = `/player/add`;
      ajax_method({
        data: sendData,
        url,
        type: 'POST',
        dataType: 'json',
        timeout: 60000,
        contentType: "application/json",
        success: (res) => {
          const resjson = JSON.parse(res)
          if (resjson.code === 1) {
            this.$message({
              type: 'success',
              message: resjson.message || '创建成功',
              duration: Infinity,
              showClose: true
            })
            this.$refs.ruleForm.resetFields();
            return
          }
          this.$message({
            type: 'error',
            message: resjson.message || '创建失败',
            duration: '3000',
          })
        },
        error: function (error) {
          this.$message({
            type: 'error',
            message: error.message,
            duration: '3000',
          })
        }
      })
    },
    handleReg(e) {
      e.preventDefault();
      if (!this.checked) {
        alert('您还没有阅读《畅游用户协议》');
        return false;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        if (this.ruleForm.type == '1') {
          this.ajaxAdd();
        }
        else {
          this.$refs.verifyCodeRef.show();
        }
      })
    },
    getFormMessageRef(prop) {
      const formMessage = this.formMessageRefs;
      const current = formMessage.find(item => item.prop === prop);
      return current;
    },
    showMessage(data, { rule }) {
      const ref = this.getFormMessageRef(rule.field);
      if (!ref) return;
      ref.showMessage(data)
    },
    focusInput(event, msg, prop) {
      this.showMessage({ type: 'focus', message: msg }, { rule: { field: prop } })
    }
  }
}
</script>

<style scoped>
@import "../assets/css/register.css";
</style>



// WEBPACK FOOTER //
// src/components/register.vue